export const cancelApplicationAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }